module.exports = __webpack_public_path__ + "img/TAMPAK DEPAN.c4a20e35.jpg";